import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { BsModalRef } from 'ngx-bootstrap';
import { ConfirmationProps } from './models/confirmation.model';

@Component({
  selector: 'app-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss']
})
export class ConfirmationComponent implements OnInit {
  public onClose: Subject<string>;
  props: ConfirmationProps;
  hideIcon: boolean = false;
  status: string = 'success';
  descArr: Array<any> = [];

  constructor(private bsModalRef: BsModalRef) {}

  ngOnInit() {
    this.onClose = new Subject();
    if (this.props && typeof this.props.showIcon !== 'undefined') {
      this.hideIcon = !this.props.showIcon;
    }
    if (this.props && typeof this.props.status) {
      this.status = this.props.status;
    }
    this.descArr = this.props.desc.split('/n');
  }

  close(response = '') {
    this.onClose.next(response);
    this.bsModalRef.hide();
  }
}
